import(/* webpackMode: "eager" */ "/vercel/path0/components/CareerIndex.js")